import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    currentList: [],
    totalButton: ''
  },
  mutations: {
    setCurrentData(state, payload) {
      state.currentList = payload.list.slice();
      state.totalButton = payload.masterButton;
    }
  },
  actions: {
    getList({ commit }, data) {
      api.getList(data).then(res => {
        commit('setCurrentData', res.data);
      });
    },
    setOneSwitch(context, { type, pair, button }) {
      return api.setOneSwitch(type, pair, button);
    },
    setTotalSwitch(context, data) {
      return api.setTotalSwitch(data);
    },
    setAuto(context, { type, pair, button }) {
      return api.setAuto(type, pair, button);
    },
    setadmin(context, { type, pair, button }) {
      return api.setadmin(type, pair, button);
    },
    setBargain(context, { content, type }) {
      return api.setBargain(content, type);
    }
  }
};

appStore.registerModule('robotpingSetting', store);
